import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConversionMetricsFacade } from './conversion-metrics.facade';
import { DashboardPageDefinition } from '../../dashboard.data';
import { ConversionCardVm, ConversionMetricsVm } from '../../domain/model/conversion-metrics.model';
import { DashboardVmState } from '../../domain/model/dashboard-vm.model';

/** Conversion metrics page: three stage-to-stage conversion cards following the shared filters. */
@Component({
  selector: 'ifbp-conversion-metrics',
  templateUrl: './conversion-metrics.component.html',
  styleUrls: ['./conversion-metrics.component.scss'],
  providers: [ConversionMetricsFacade],
  standalone: false,
})
export class ConversionMetricsComponent implements OnInit {
  page$: Observable<DashboardPageDefinition>;
  vm$: Observable<ConversionMetricsVm>;
  readonly VmState = DashboardVmState;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly facade: ConversionMetricsFacade,
  ) {}

  ngOnInit(): void {
    this.page$ = this.route.data.pipe(map((data: Data) => data.dashboardPage as DashboardPageDefinition));
    this.vm$ = this.facade.vm$;
  }

  /** The three cards are fixed and distinct; their titles are the stable key. */
  trackByCard(_index: number, card: ConversionCardVm): string {
    return card.title;
  }
}
